import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted === null) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setIsVisible(false);
    localStorage.setItem('cookiesAccepted', 'true');
  };

  const handleDecline = () => {
    setIsVisible(false);
    localStorage.setItem('cookiesAccepted', 'false');
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <p>
            We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
            By clicking "Accept All", you consent to our use of cookies.{' '}
            <a href="/cookie-policy" className="cookie-banner-link">
              Learn more
            </a>
          </p>
        </div>
        <div className="cookie-banner-buttons">
          <button
            className="cookie-banner-btn cookie-banner-decline"
            onClick={handleDecline}
          >
            Decline
          </button>
          <button
            className="cookie-banner-btn cookie-banner-accept"
            onClick={handleAccept}
          >
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
